module.exports = __webpack_public_path__ + "static/img/home_lun5.3977e85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/home_lun5.jpg
// module id = GV/V
// module chunks = 1